import { render, staticRenderFns } from "./MeuPlano.vue?vue&type=template&id=097d69e6"
import script from "./MeuPlano.vue?vue&type=script&lang=js"
export * from "./MeuPlano.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports